/**
 * Who may be turned off, and if not, why. Shown next to the disabled button so
 * the reason never hides in a tooltip alone. The server refuses the same cases
 * (409), so this is presentation only.
 */

import type { UserRow } from "./types";

// The server's own 409 sentences, so the disabled button and a refusal read the same.
export const SELF_REASON = "You cannot turn off your own access.";
export const ADMIN_REASON =
  "This person is a workbench admin. Remove them from WORKBENCH_ADMIN_EMAILS first.";

export function blockedReason(user: UserRow, myEmail: string | undefined): string | null {
  if (user.email === myEmail) return SELF_REASON;
  if (user.is_admin) return ADMIN_REASON;
  return null;
}
